export const myLesson = {
    "not_lesson_yet": "No lesson yet",
    "completed_prerequisite_lessons": "You have not completed prerequisite lessons yet. Let follow the lessons' order!",
};
